export default __webpack_public_path__ + "static/media/wallet.f0d664df.png";